import { get } from '@/utils/request';

export const temp_categorys = (params) => {
  return get('/api/v1/temp_categorys', params);
};
export const temps = (params) => {
  return get('/api/v1/temps', params);
};

export const temp = (id) => {
  return get(`/api/v1/temp/${id}`);
};

export const other_category_temps = (params) => {
  return get('/api/v1/other_category_temps', params);
};
